import DeviceDetector from 'device-detector-js'

export default function getDeviceType () {
  const userAgent = typeof window !== 'undefined' && window.navigator.userAgent
  const deviceDetector = new DeviceDetector()
  const device = userAgent && deviceDetector.parse(userAgent)
  return device
}
